import React from 'react';
// import { Link } from 'react-router';
// import { prefixLink } from 'gatsby-helpers';

const Template = (props) => (
    <div>{props.children}</div>
);

export default Template;



// WEBPACK FOOTER //
// ./templates/_template.js